#import "./UserDefaultFields.graphql"

mutation UserDefaultUpdate($input: UserDefaultUpdateInput!) {
  userDefaultUpdate(input: $input) {
    userDefault {
      ...UserDefaultFields
      lookupAccounts {
        lookupAccount
        lookupName
      }
      lookupAccountId
      referenceCode6
      referenceCode7
      _homeCountryId
    }
  }
}
